module.exports = __webpack_public_path__ + "frontend/images/agents/mr-tan-just-moved-xs-a658140d555f2c0491f76e91dc44668c.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/mr-tan-just-moved-xs.jpg
// module id = 359
// module chunks = 2